import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row items-center no-wrap gk-chin-row" }
const _hoisted_2 = { class: "quick-text" }
const _hoisted_3 = {
  key: 0,
  class: "quick-title"
}
const _hoisted_4 = {
  key: 1,
  class: "quick-title"
}
const _hoisted_5 = {
  key: 2,
  class: "quick-subtitle"
}

import {
  ref, reactive, computed, onMounted, onBeforeUnmount, PropType,
} from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { GoskluchSignStatus } from '@/store/ecohospital/types';

type UserDocument = {
  att_type: number;
  checksum: number;
  date_doc: string;
  datebegin: string;
  doc_name: string;
  doc_type: number;
  file_ext: string;
  id_document: number;
  id_patient: number;
  is_napravlenie: number;
  goskluch: boolean;
  tg: string;
};

const THICKNESS = 24;

export default /*@__PURE__*/_defineComponent({
  __name: 'GoskluchSignButton',
  props: {
  document: {
    type: Object as () => UserDocument,
  },
  status: {
    type: Object as PropType<GoskluchSignStatus | null>,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ['handleSign', 'refreshStatus'],
  setup(__props, { emit: __emit }) {

const props = __props;

const $q = useQuasar();
const isMobile = $q.platform.is.mobile;

const emit = __emit;

// -1 — ошибка, 0 — ожидаем подписания, 1 — подписано
const isSigned = computed(() => Number(props.status?.signed) === 1);
const isError = computed(() => Number(props.status?.signed) === -1);
const isPending = computed(() => !!props.status && !isSigned.value && !isError.value);

const statusClass = computed(() => {
  if (isSigned.value) return 'gk-status--signed';
  if (isError.value) return 'gk-status--error';
  if (isPending.value) return 'gk-status--pending';
  return '';
});

const actionIcon = computed(() => {
  if (isSigned.value) return 'check_circle';
  if (isPending.value) return 'refresh';
  return 'open_in_new';
});

const wrapRef = ref<HTMLElement | null>(null);
const tapeStyle = reactive({
  width: '0px',
  left: '0px',
  top: '0px',
  transformOrigin: '0px 50%',
  transform: 'rotate(0deg)',
});

const HALF_T = THICKNESS / 2;

const onCardTap = () => {
  if (props.loading || isSigned.value) return;
  if (isPending.value) {
    emit('refreshStatus');
    return;
  }
  // if (!isMobile) return;
  // $q.notify({
  //   type: 'warning',
  //   message: 'Чиним! Приносим извинения за неудобство!',
  //   caption:
  // 'Для экономии времени в поликлинике, пожалуйста, распечатайте и подпишите документ заранее.',
  //   position: 'top',
  //   timeout: 5000,
  //   multiLine: true,
  // });
  emit('handleSign', props.document);
};

function updateTape() {
  const el = wrapRef.value;
  if (!el) return;
  const w = el.clientWidth;
  const h = el.clientHeight;

  // точки крепления: левый нижний угол → середина правой грани
  const ax = w / 2;
  const ay = h;
  const bx = w;
  const by = h / 2;
  const dx = bx - ax;
  const dy = by - ay;
  const length = Math.sqrt(dx * dx + dy * dy);
  const angle = (Math.atan2(dy, dx) * 180) / Math.PI;

  const overshoot = Math.max(w, h);

  tapeStyle.width = `${length + overshoot * 2}px`;
  tapeStyle.left = `${ax - overshoot}px`;
  tapeStyle.top = `${ay - HALF_T}px`;
  tapeStyle.transformOrigin = `${overshoot}px 50%`;
  tapeStyle.transform = `rotate(${angle}deg)`;
}

let observer: ResizeObserver | null = null;
onMounted(() => {
  updateTape();
  if (wrapRef.value) {
    observer = new ResizeObserver(updateTape);
    observer.observe(wrapRef.value);
  }
});
onBeforeUnmount(() => observer?.disconnect());

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gk-chin-card", { 'gk-chin-card--static': isSigned.value }]),
    ref_key: "wrapRef",
    ref: wrapRef,
    onClick: onCardTap
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"quick-icon-box\" data-v-4d5b665d><svg width=\"26\" height=\"26\" viewBox=\"0 0 36 36\" data-v-4d5b665d><defs data-v-4d5b665d><mask id=\"key-cutout\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"36\" height=\"36\" data-v-4d5b665d><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" fill=\"#ffffff\" data-v-4d5b665d></rect><rect x=\"6.33\" y=\"10.71\" width=\"9.71\" height=\"2.57\" rx=\"1\" ry=\"1\" transform=\"translate(-5.21 11.43) rotate(-45)\" fill=\"#000000\" data-v-4d5b665d></rect></mask></defs><g transform=\"translate(36,0) scale(-1,1)\" data-v-4d5b665d><g mask=\"url(#key-cutout)\" data-v-4d5b665d><path d=\"M23.35,16.8l.63-.63A5,5,0,0,0,24,9.1L18.71,3.84a5,5,0,0,0-7.07,\n              0L3.09,12.39a5,5,0,0,0,0,7.07l5.26,5.26a5,5,0,0,0,7.07,0l.4-.4L18,\n              26.48h3.44v3h3.69v1.63L28,34h6V27.45Z\" fill=\"#2563eb\" stroke=\"#2563eb\" stroke-width=\"0.75\" stroke-linejoin=\"round\" data-v-4d5b665d></path></g></g></svg></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        (__props.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createTextVNode(" Статус подписания ГОСКЛЮЧОМ: ", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(statusClass.value)
              }, _toDisplayString(__props.status.signed_str), 3)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, "Подписать ГОСКЛЮЧОМ")),
        (isError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Нажмите, чтобы отправить на подписание повторно "))
          : _createCommentVNode("", true)
      ]),
      (__props.loading)
        ? (_openBlock(), _createBlock(_component_q_spinner, {
            key: 0,
            size: "20px",
            class: "quick-arrow"
          }))
        : (_openBlock(), _createBlock(_component_q_icon, {
            key: 1,
            name: actionIcon.value,
            size: "20px",
            class: _normalizeClass(
      ['quick-arrow', { [statusClass.value]: !isPending.value }])
          }, null, 8, ["name", "class"]))
    ])
  ], 2))
}
}

})